import axios from 'axios';
import history from '../history';
import Cookies from 'js-cookie';
import {CONFIG_UTIL} from '../config';
import { head, isFunction } from 'lodash';

var url = window.location.search;
var token = Cookies.get('Set-Cookie');

var header = {};

// if( token === undefined || token === null )
//     history.push('/login')

if(url.includes("register-psep")){
    header = {
        'Accept':  'application/json',
        'Content-Type': 'application/json',
    }
}else {
    if( token === undefined || token === null || token === "null") {
        history.push('/login')
    }else{
        header = {
            'Accept':  'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        };
    }
}

const instance = axios.create({
    baseURL: CONFIG_UTIL.UTIL_MANAGEMENT_HOST,
    headers: header
});

instance.defaults.withCredentials = false;
instance.interceptors.response.use(response => {
    // if(response.data.errorSchema.errorCode === "EP-005") {
    //     Cookies.remove('Set-Cookie'); 
    //     window.location.assign('/login');
    // }    
    //console.log(response)
    return response;
}, error => {
    //Cookies.remove('Set-Cookie'); 
    //history.push('/login')
});

export default instance;